// eslint-disable-next-line import/order
import './instruments';
// eslint-disable-next-line import/order

import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ApolloProvider } from '@apollo/client';
import client from 'src/graphql/client';
import { AuthProvider } from 'src/utils/auth';

import App from './App';
import './init/init.css';
import './index.css';

const container = document.getElementById('root')!;
const root = ReactDOM.createRoot(container);
root.render(
  <ApolloProvider client={client}>
    <GoogleReCaptchaProvider
      useEnterprise
      reCaptchaKey={import.meta.env.VITE_RECAPTCHA_KEY}
    >
      <AuthProvider>
        <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </GoogleOAuthProvider>
      </AuthProvider>
    </GoogleReCaptchaProvider>
  </ApolloProvider>
);
